const styles = `:host {
  width: 100%;
}

:host([outlined]) ::slotted(chameleon-accordion-item) {
  border-top: 1px solid var(--goto-field-01);
  display: block;
}
:host([outlined]) ::slotted(:last-child) {
  border-bottom: 1px solid var(--goto-field-01);
}`; export default styles;